import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumSupplierSource, EnumSupplierSourceOption } from "./EnumSupplierSource";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoCallbackSupplier extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 来源
     */
    SupplierSource?: EnumSupplierSource;
    /**
     * 类型
     */
    SupplierCompanyTypeId?: string;
    /**
     * 类型
     */
    SupplierCompanyTypeLabel?: string;
    /**
     * 供应商名称
     */
    SupplierCompanyId?: string;
    /**
     * 供应商名称
     */
    SupplierCompanyLabel?: string;
    /**
     * 联系人
     */
    SupplierCompanyContactLabel?: string;
}

/**
 * -表单校验
 */
export const DtoCallbackSupplierRules = {
    SupplierSource: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    SupplierCompanyId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    SupplierCompanyContactLabel: [
        {
            max: 1024,
            message: "文本长度不能超过 1024 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * -设置项
 */
export const DtoCallbackSupplierMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "SupplierSource",
    Label: "来源",
    Customize: true,
  },
  {
    Prop: "SupplierCompanyTypeId",
    Label: "类型",
    Customize: true,
  },
  {
    Prop: "SupplierCompanyId",
    Label: "供应商名称",
    Customize: true,
  },
  {
    Prop: "SupplierCompanyContactLabel",
    Label: "联系人",
    Customize: true,
  },
]
